export default __webpack_public_path__ + "static/media/s12.acb0e469.png";